import styles from './PageHero.module.scss'

import React from 'react'
import classnames, { Value } from 'classnames'
import Container from '../Container/Container'
import Header from '../Header/Header'

interface Props {
    className?: Value
    image: string
    title: string
}

const PageHero: React.FC<Props> = ({ className, image, title }) => {
    return (
        <div className={classnames(styles.container, className)}>
            <div className={styles.bg} style={{ backgroundImage: `url(${image})` }} />
            <Container className={styles.inner}>
                <Header className={styles.header} />
                <div className={styles.titleContainer}>
                    <h2 className={styles.title}>{title}</h2>
                </div>
            </Container>
        </div>
    )
}

export default PageHero
